import {IComponentController, IComponentOptions} from "angular";
import {CustomerFilter} from "modules/customers/model/CustomerFilter";
import {Status} from "modules/filter_components/components/status-picker/StatusEnum";


export class StatusSelector implements IComponentController {
    selectedStatuses: string[] = [];
    statuses: Status[] = Object.values(Status)
    filter: CustomerFilter;

    public static instance: IComponentOptions = {
        bindings: {
            filter: '='
        },
        controller: StatusSelector,
        template: require('./funnel-status-piecker.component.html')
    }


    updateFilter() {
        this.filter.statuses = this.selectedStatuses;
    }

    $onInit() {
        this.selectedStatuses = this.filter.statuses || [];
    }





}


